import Home from './routes/home/Home';
import PageNotFound from './components/PageNotFound';
import OuterLayout from './components/OuterLayout';
import RouteHelper from './helpers/RouteHelper';
import RaffleDetail from './routes/raffle/RaffleDetail';
import RaffleForm from './routes/raffle/RaffleForm';
import ShippingPage from './routes/shipping/ShippingPage';
import ThankYouPage from './routes/thankYou/container';
import PaymentRepeating from './routes/paymentRepeating/container';

const coreRoutes = [
	{ name: '/homepage',
		path: '/',
		exact: true,
		strict: false,
		component: Home,
	},
	{ name: '/shipping',
		path: '/shipping',
		exact: true,
		strict: false,
		component: ShippingPage,
	},
	{ name: '/raffle-detail',
		path: '/:slugAndId(.+-[-_A-Za-z0-9]{20})',
		exact: true,
		strict: false,
		component: RaffleDetail,
	},
	{ name: '/register',
		path: '/register/:raffleId/:sex/:sizeId/:paymentStatus?/:registrationId?/:country?',
		exact: true,
		strict: true,
		modifyHeader: true,
		component: RaffleForm,
	},
	{
		name: '/registration/finish',
		path: '/registration/finish/:registrationId/:userStatus/:raffleClosedAt?',
		exact: true,
		strict: true,
		component: ThankYouPage
	},
	{
		name: '/registration/repeat-payment',
		path: '/registration/repeat-payment/:registrationId',
		exact: true,
		strict: true,
		component: PaymentRepeating
	},
	// { name: '/about',
	// 	path: '/about',
	// 	exact: false,
	// 	strict: false,
	// 	component: Home,
	// 	routes: [
	// 		{ name: '/about',
	// 			path: '/about',
	// 			exact: true,
	// 			strict: false,
	// 			component: Home
	// 		}
	// 	]
	// },
	{ name: '/404',
		path: '/*',
		showNavbar: false,
		component: PageNotFound,
	}
];

/**
 * Walk route tree and add default meta title if it is no declared above
 */
const addDefaultMetaTitle = () => {
	coreRoutes.forEach(route => {
		if(!route.metaTitle) {
			route.metaTitle = 'Footshop - Releases';
		}
	})
};
addDefaultMetaTitle();

/**
 * Walk route tree and build full paths (including parent paths)
 *
 * @param {array} parentPaths
 * @param routes
 * @return {*}
 */
const buildRoutesWithParentPath = (parentPaths, routes) => routes.map((route) => {
	const builtPaths = [];
	parentPaths.forEach((parentPath) => {
		// Route path can be array of possible paths and we need to take that
		// into account when generating child paths.. Since our primary route has multiple
		// possible paths (/, /en, /en-eur), all of her descendants will also need to have
		// multiple paths defined (/about, /en/about, /en-eur/about)
		if (Array.isArray(route.path)) {
			route.path.forEach((possiblePath) => {
				builtPaths.push(parentPath + possiblePath);
			});
		}
		else {
			builtPaths.push(parentPath + route.path);
		}
	});
	const builtRoute = {
		...route,
		path: builtPaths
	};
	if (route.routes) {
		builtRoute.routes = buildRoutesWithParentPath(builtPaths, route.routes);
	}
	return builtRoute;
});

/**
 * Build Routes from state
 *
 * @param state
 * @return {*[]}
 */
const buildRoutes = (state) => {
	const basePaths = [
		RouteHelper.getBasePathWithMutationAndCurrencyExpression(state),
		RouteHelper.getBasePathWithMutationExpression(state),
		''
	];

	return [
		{ name: '/:mutation-:currency',
			path: basePaths,
			handleMutationAndCurrency: true,
			component: OuterLayout,
			routes: buildRoutesWithParentPath(basePaths, coreRoutes)
		}
	];
};

export default buildRoutes;



// WEBPACK FOOTER //
// ./routes.js